import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";


import { ReactComponent as ActiveImg } from "../../../img/ico-status-stable.svg";
import { ReactComponent as ErrorImg } from "../../../img/ico-status-error.svg";
import { ReactComponent as AlertImg } from "../../../img/ico-status-alert.svg";
import { ReactComponent as IdleImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as RunningImg } from "../../../img/ico-account-sleeper.svg";
import { ReactComponent as DownImg } from "../../../img/ico-account-idle.svg";
import { ReactComponent as LockImg } from "../../../img/ico-prefix-lock.svg";
import { ReactComponent as UnlockImg } from "../../../img/ico-prefix-unlock.svg";

import VmAdd from "./VmAdd";
import VmUpdate from "./VmUpdate";

import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import VmSnapshotAdd from "./VmSnapshotAdd";
import VmNetworkPortUpdate from "./VmNetworkPortUpdate";
import VmNetworkPortAdd from "./VmNetworkPortAdd";
import VmFloatingIpAdd from "./VmFloatingIpAdd";
import VmSecurityGroupAdd from "./VmSecurityGroupAdd";
import VmVolumeAdd from "./VmVolumeAdd";


interface VmTypeData {
    vm_type_id: string;
    vm_type_name: string;
    host_cluster_type_code: string;
    share_type_code: string;
    vcpu_count: number;
    memory_capacity_mb: number;
    root_disk_capacity_gb: number;
    ephemeral_disk_capacity_gb: number;
    swap_disk_capacity_mb: number;
    rx_tx_factor: number;
    gpu_available_yn: boolean;
}


interface VmImageData {
    vm_image_id: string;
    vm_image_name: string;
}


interface VmProjectData {
    project_id: string;
    project_name: string;
}


interface VmRootVolumeData {
    volume_id: string;
    volume_name: string;
    volume_description: string;
    volume_size_gb: number;
    volume_status_code: string;
    boot_yn: boolean;
    mapping_device_name: string;
    root_disk_yn: boolean;
}

interface VmHostData {
    host_name: string;
    host_id: string;
}


interface VmVolumeData {
    volume_id: string;
    volume_name: string;
    volume_description: string;
    volume_status_code: string;
    boot_yn: boolean
    volume_size_gb: number;
    mapping_device_name: string;
    root_disk_yn: boolean;
}

interface SecurityGroupsRulesData {
    security_group_rule_id: string;
    security_group_rule_type_code: string;
    direction_type_code: string;
    open_port_type_code: string;
    remote_type_code: string;
    min_port: number;
    max_port: number;
    remote_cidr: string;
    ip_protocol: number;
    remote_security_group_id: string;
    remote_security_group_name: string;
}


export interface SecurityGroupsData {
    security_group_id: string;
    security_group_name: string;
    security_group_rules: SecurityGroupsRulesData[];
}


interface NetworkPortsData {
    network_port_id: string;
    network_port_name: string;
    network_port_status_code: string;
    bind_type_code: string;
    up_yn: boolean;
    security_yn: boolean;
    mac_address: string;
    fixed_ip_address: string;
    floating_ip: {
        floating_ip_address: string;
        floating_ip_id: string;
        floating_ip_status_code: string;
    };
    network: {
      network_id: string;
      network_name: string;
      external_yn: boolean;
    }
    subnet: {
      subnet_id: string;
      subnet_name: string;
      cidr: string;
      gateway_ip_address: string;
    }
    security_groups: SecurityGroupsData[]
}

export interface VmData {
    vm_id: string;
    vm_name: string;
    vm_description: string;
    vm_type_code: string;
    vm_status_code: string;
    power_state_code: string;
    gpu_passthrough_yn: boolean;
    vm_type: VmTypeData
    vm_type_name: string;
    vm_image: VmImageData;
    vm_image_name: string;
    vm_key_pair: string;
    vm_key_pair_name: string;
    ip_addresses: string;
    project: VmProjectData;
    availability_zone_id: string;
    host_name: string;
    root_volume_id: string;
    root_volume: VmRootVolumeData;
    host: VmHostData;
    create_ts: string;
    update_ts: string;
    volumes: VmVolumeData[]
    network_ports: NetworkPortsData[]
    security_groups: SecurityGroupsData[]
}




export const categoryFilters:ListFilter[] = [
    {
        id: 1,
        name: i18n.t("TOTAL_TEXT"),
        type: "",
        code: "",
        count: 0
    },
    {
        id: 2,
        name: i18n.t("ACTIVE_TEXT"),
        type: "vmStatusCode",
        code: "ACT",
        count: 0
    },
    {
        id: 3,
        name: i18n.t("SHUTOFF_TEXT"),
        type: "vmStatusCode",
        code: "SOFF",
        count: 0
    },
    {
        id: 4,
        name: i18n.t("DELETED_TEXT"),
        type: "vmStatusCode",
        code: "DEL",
        count: 0
    },
    {
        id: 5,
        name: i18n.t("ERROR_TEXT"),
        type: "vmStatusCode",
        code: "ERR",
        count: 0
    },
    {
        id: 6,
        name: i18n.t("BUILD_TEXT"),
        type: "vmStatusCode",
        code: "BLD",
        count: 0
    },
    {
        id: 7,
        name: i18n.t("MIGRATING_TEXT"),
        type: "vmStatusCode",
        code: "MIG",
        count: 0
    },
    {
        id: 8,
        name: i18n.t("PAUSED_TEXT"),
        type: "vmStatusCode",
        code: "PAUSE",
        count: 0
    },
    {
        id: 9,
        name: i18n.t("RESCUE_TEXT"),
        type: "vmStatusCode",
        code: "RCUE",
        count: 0
    },
    {
        id: 10,
        name: i18n.t("REBUILD_TEXT"),
        type: "vmStatusCode",
        code: "RBLD",
        count: 0
    },
    {
        id: 11,
        name: i18n.t("REBOOT_TEXT"),
        type: "vmStatusCode",
        code: "RBOOT",
        count: 0
    },
    {
        id: 12,
        name: i18n.t("RESIZE_TEXT"),
        type: "vmStatusCode",
        code: "RSIZE",
        count: 0
    },
    {
        id: 13,
        name: i18n.t("REVERT_RESIZE_TEXT"),
        type: "vmStatusCode",
        code: "RVRSIZE",
        count: 0
    },
    {
        id: 14,
        name: i18n.t("HARD_REBOOT_TEXT"),
        type: "vmStatusCode",
        code: "HDRBOOT",
        count: 0
    },
    {
        id: 15,
        name: i18n.t("SOFT_DELETED_TEXT"),
        type: "vmStatusCode",
        code: "SFDEL",
        count: 0
    },
    {
        id: 16,
        name: i18n.t("SUSPENDED_TEXT"),
        type: "vmStatusCode",
        code: "SUSP",
        count: 0
    },
    {
        id: 17,
        name: i18n.t("UNKNOWN_TEXT"),
        type: "vmStatusCode",
        code: "UNK",
        count: 0
    },
];


export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("VM_CREATION_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "VM_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("VM_CONTROL_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.CONTROL_BUTTON,
        activeYn: true,
        controlButton: [
            {
                name: i18n.t("START_TEXT"),
                code: "ACTION_START",
            },
            {
                name: i18n.t("STOP_TEXT"),
                code: "ACTION_STOP",
            },
            {
                name: i18n.t("PAUSED_TEXT"),
                code: "ACTION_PAUSE",
            },
            {
                name: i18n.t("RESUME_TEXT"),
                code: "ACTION_RESUME"
            },
            {
                name: i18n.t("REBOOT_TEXT"),
                code: "ACTION_REBOOT"
            },
            {
                name: i18n.t("MIGRATING_TEXT"),
                code: "ACTION_MIGRATION"
            }
        ],
    },
    {
        id: 3,
        name: i18n.t("DELETE_SELECTED_ITEM_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "VM_DELETE",
        },
    },
    {
        id: 4,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "VM_SYNC",
        },
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("VM_NAME_TEXT"),
        accessor: "vm_name",
        disableSortBy: false,
        style: {
            width: "140px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("VM_TYPE_TEXT"),
        accessor: "vm_type_code",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>
                {
                    value === "SVC" ?
                        <div style={className.usageTypeContainerService}>
                            <>{i18n.t("SERVICE_TEXT")}</>
                        </div>
                    : value === "CONTNODE" ?
                        <div style={className.usageTypeContainerContNode}>
                            <>{i18n.t("CONTNODE_TEXT")}</>
                        </div>
                    : value === "MGMT" ?
                        <div style={className.usageTypeContainerManagement}>
                            <>{i18n.t("MANAGEMENT_TEXT")}</>
                        </div>
                    :
                        <div style={className.usageTypeContainerUnknown}>
                            <>{i18n.t("UNKNOWN_TEXT")}</>
                        </div>
                }
            </div>
        )
    },
    {
        Header: i18n.t("IP_ADDRESS_TEXT"),
        accessor: "ip_addresses",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#5c5c5c"}}>{value}</div>)
    },
    {
        Header: i18n.t("VM_BASE_IMAGE_TEXT"),
        accessor: "vm_image",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value?.vm_image_name ? value.vm_image_name : ""}</div>)
    },
    {
        Header: i18n.t("VM_STATUS_TEXT"),
        accessor: "vm_status_code",
        disableSortBy: true,
        style: {
            width: "90px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: "#616266",
                overflow: "hidden"
            }}>
                {
                    (() => {
                        if(value === "ACT")
                            return (
                            <div style={{...className.statusInnerContainer, color:"#3a8344"}}>
                                <ActiveImg style={className.statusImg}/> Active
                            </div>)
                        else if(value === "SOFF")
                            return (
                            <div style={{...className.statusInnerContainer, color:"#8c8c8c"}}>
                                <ErrorImg style={className.statusImg}/> Down
                            </div>)
                        else if(value === "ERR")
                            return (
                            <div style={{...className.statusInnerContainer, color:"#e86045"}}>
                                <ErrorImg style={className.statusImg}/> Error
                            </div>)
                        else if(value === "BLD")
                            return (
                            <div style={{...className.statusInnerContainer, color:"#edbf1a"}}>
                                <AlertImg style={className.statusImg}/> Build
                            </div>)
                        else if(value === "UNK")
                            return (
                            <div style={{...className.statusInnerContainer, color:"#8c8c8c"}}>
                                <IdleImg style={className.statusImg}/> Unknown
                            </div>)
                        else
                            return (
                            <div style={{...className.statusInnerContainer, color:"#8c8c8c"}}>
                                <IdleImg style={className.statusImg}/> {value}
                            </div>)
                    })()
                }
            </div>
        )
    },
    {
        Header: i18n.t("VM_POWER_STATUS_TEXT"),
        accessor: "power_state_code",
        disableSortBy: true,
        style: {
            width: "90px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.statusContainer}>
                {
                    (() => {
                        if(value === "RUN")
                            return (
                            <div style={className.statusInnerContainer}>
                                <RunningImg /> Running
                            </div>)
                        else if(value === "STDWN")
                            return (
                            <div style={className.statusInnerContainer}>
                                <DownImg />Down
                            </div>)
                        else
                            return (
                            <div style={className.statusInnerContainer}>
                                <DownImg />Down
                            </div>)

                    })()
                }
            </div>
        )
    },
    {
        Header: i18n.t("VM_KEY_PAIR_TEXT"),
        accessor: "vm_key_pair_name",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#0853fb"}}>{value}</div>)
    },
    {
        Header: i18n.t("VM_AVAIL_ZONE_TEXT"),
        accessor: "availability_zone_id",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("VM_PROJECT_TEXT"),
        accessor: "project",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#0853fb"}}>{value?.project_name ? value.project_name : ""}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
];

export const vmAddModalContent = {
    title: i18n.t("VM_CREATION_TEXT"),
    stepCount: 5,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 1,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 2,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 3,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 4,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        }
    ],
    innerComponent: <VmAdd />,
}



export const vmUpdateModalContent = {
    title: i18n.t("VM_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <VmUpdate />,
}

export const snapshotAddModalContent = {
    title: i18n.t("VM_SNAPSHOT_ADD_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <VmSnapshotAdd />,
}

export const networkPortUpdateModalContent = {
    title: i18n.t("VM_NETWORK_PORT_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <VmNetworkPortUpdate />,
}

export const networkPortAddModalContent = {
    title: i18n.t("VM_NETWORK_PORT_ADD_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <VmNetworkPortAdd />,
}

export const floatingIpAddModalContent = {
    title: i18n.t("VM_FLOATING_IP_ADD_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CONNECT_TEXT")
        },
    ],
    innerComponent: <VmFloatingIpAdd />,
}

export const securityGroupAddModalContent = {
    title: i18n.t("VM_SECURITY_GROUP_ADD_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("ADD_TEXT")
        },
    ],
    innerComponent: <VmSecurityGroupAdd />,
}


export const volumeAddModalContent = {
    title: i18n.t("VM_VOLUME_ADD_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("ADD_TEXT")
        },
    ],
    innerComponent: <VmVolumeAdd />,
}

export const diskTypes = [
    {
        label: i18n.t("IMAGE_TYPE_TEXT"),
        value: "IMG"
    },
    {
        label: i18n.t("VOLUME_TYPE_TEXT"),
        value: "VOL"
    },
    {
        label: i18n.t("IMAGE_SNAPSHOT_TYPE_TEXT"),
        value: "SNAP"
    },
    {
        label: i18n.t("VOLUME_SNAPSHOT_TYPE_TEXT"),
        value: "VOLSNAP"
    },
]

export const vmTypes = [
    {
        label: i18n.t("SERVICE_TEXT"),
        value: "SVC"
    },
    {
        label: i18n.t("CONTNODE_TEXT"),
        value: "CONTNODE"
    },
    {
        label: i18n.t("MANAGEMENT_TEXT"),
        value: "MGMT"
    },
]

export const osTypes = [
    {
        label: i18n.t("BLANK_DISK_TEXT"),
        value: "BLNK"
    },
    {
        label: "Windows 7",
        value: "WIN7",
    },
    {
        label: "Windows 10",
        value: "WIN10",
    },
    {
        label: "Windows Server 2019",
        value: "WIN2019"
    },
    {
        label: "Windows Server 2022",
        value: "WIN2022"
    },
    {
        label: "Other OS",
        value: "OTHR",
    },
    {
        label: "Linux",
        value: "LNX",
    },
    {
        label: "RHEL 8",
        value: "RHEL8",
    },
    {
        label: "RHEL 9",
        value: "RHEL9",
    },
    {
        label: "Ubuntu 18.04",
        value: "UBT1804",
    },
    {
        label: "Ubuntu 20.04",
        value: "UBT2004"
    },
    {
        label: "Debian 7",
        value: "DBA7"
    },
    {
        label: "Debian 9",
        value: "DBA9"
    },

]


export const hourTypes = [
    {
        label: "1" + i18n.t("HOUR_TEXT"),
        value: "1"
    },
    {
        label: "2" + i18n.t("HOUR_TEXT"),
        value: "2"
    },
    {
        label: "3" + i18n.t("HOUR_TEXT"),
        value: "3"
    },
    {
        label: "4" + i18n.t("HOUR_TEXT"),
        value: "4"
    },
    {
        label: "5" + i18n.t("HOUR_TEXT"),
        value: "5"
    },
    {
        label: "6" + i18n.t("HOUR_TEXT"),
        value: "6"
    },
    {
        label: "7" + i18n.t("HOUR_TEXT"),
        value: "7"
    },
    {
        label: "8" + i18n.t("HOUR_TEXT"),
        value: "8"
    },
    {
        label: "9" + i18n.t("HOUR_TEXT"),
        value: "9"
    },
    {
        label: "10" + i18n.t("HOUR_TEXT"),
        value: "10"
    },
    {
        label: "11" + i18n.t("HOUR_TEXT"),
        value: "11"
    },
    {
        label: "12" + i18n.t("HOUR_TEXT"),
        value: "12"
    },
    {
        label: "13" + i18n.t("HOUR_TEXT"),
        value: "13"
    },
    {
        label: "14" + i18n.t("HOUR_TEXT"),
        value: "14"
    },
    {
        label: "15" + i18n.t("HOUR_TEXT"),
        value: "15"
    },
    {
        label: "16" + i18n.t("HOUR_TEXT"),
        value: "16"
    },
    {
        label: "17" + i18n.t("HOUR_TEXT"),
        value: "17"
    },
    {
        label: "18" + i18n.t("HOUR_TEXT"),
        value: "18"
    },
    {
        label: "19" + i18n.t("HOUR_TEXT"),
        value: "19"
    },
    {
        label: "20" + i18n.t("HOUR_TEXT"),
        value: "20"
    },
    {
        label: "21" + i18n.t("HOUR_TEXT"),
        value: "21"
    },
    {
        label: "22" + i18n.t("HOUR_TEXT"),
        value: "22"
    },
    {
        label: "23" + i18n.t("HOUR_TEXT"),
        value: "23"
    },
    {
        label: "24" + i18n.t("HOUR_TEXT"),
        value: "24"
    },
]


export const minuteTypes = [
    {
        label: "0" + i18n.t("MINUTE_TEXT"),
        value: "0"
    },
    {
        label: "5" + i18n.t("MINUTE_TEXT"),
        value: "5"
    },
    {
        label: "10" + i18n.t("MINUTE_TEXT"),
        value: "10"
    },
    {
        label: "15" + i18n.t("MINUTE_TEXT"),
        value: "15"
    },
    {
        label: "20" + i18n.t("MINUTE_TEXT"),
        value: "20"
    },
    {
        label: "25" + i18n.t("MINUTE_TEXT"),
        value: "25"
    },
    {
        label: "30" + i18n.t("MINUTE_TEXT"),
        value: "30"
    },
    {
        label: "35" + i18n.t("MINUTE_TEXT"),
        value: "35"
    },
    {
        label: "40" + i18n.t("MINUTE_TEXT"),
        value: "40"
    },
    {
        label: "45" + i18n.t("MINUTE_TEXT"),
        value: "45"
    },
    {
        label: "50" + i18n.t("MINUTE_TEXT"),
        value: "50"
    },
    {
        label: "55" + i18n.t("MINUTE_TEXT"),
        value: "55"
    },

]

const className = {
    rowContainer: {
        width: "100%"
    },
    statusContainer: {
        width: "100px",
        display: "flex",
        alignItems: "center",
    },
    statusInnerContainer: {
        display: "flex", alignItems: "center",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        lineHeight: "1",
        color: "#9ea0a5",
        overflow: "hidden"
    },
    usageTypeContainerService: {
        width: 48, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#5b9782",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#fff",
    },
    usageTypeContainerContNode: {
        width: 120, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#f5ddd0",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#cc7e52",
    },
    usageTypeContainerManagement: {
        width: 90, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#fbefc9",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#92782f",
    },
    usageTypeContainerUnknown: {
        width: 48, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#c1c7cc",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#fff",
    },
}